import { Box, Button, Image, Text, VStack } from "@chakra-ui/react";

import BackwardsArrow from "../../../resources/icons/arrow-turn-backward.svg";
import { Link } from "react-router-dom";
import React from "react";
import Sun from "../../../resources/images/sun.svg";

export const ComingSoon: React.FC = () => {
    return (
        <Box
        display="flex" 
        justifyContent="center" 
        alignItems="center" 
        height="100vh">
            <VStack paddingX={4}>
                <Image src={Sun}/>
                <Text textAlign="center" fontSize={{ base: "28px", md: "30px", lg: "32px" }} fontWeight="700">
                A STRONGER TOMORROW FOR OUR SAMAJ IS TAKING SHAPE!
                </Text>
                <Text textAlign="center" fontSize={{ base: "18px", md: "20px", lg: "24px" }} fontWeight={{ base: "500", sm: "200", md: "300" }}>
                New features, crafted to celebrate our unity and heritage, are coming soon. Together, we rise!
                </Text>
                <Link to="/">
                    <Button paddingX="16px" paddingY="30px" borderRadius="12px" backgroundColor="rgba(255, 188, 120, 0.34);">
                        Back to home
                        <Image paddingLeft={2} src={BackwardsArrow}/>
                    </Button>
                </Link>
            </VStack>
        </Box>
    )
}